// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"TourLoadingIndicator_loadingWrapper__inXLf"};